import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatSidenavContainer, MatSidenav } from '@angular/material/sidenav';
import { MatNavList, MatListItem } from '@angular/material/list';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-free-trial-administration',
    templateUrl: './free-trial-administration.component.html',
    styleUrls: ['./free-trial-administration.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatSidenavContainer, MatSidenav, MatNavList, MatListItem, RouterLink, RouterLinkActive, RouterOutlet]
})
export class FreeTrialAdministrationComponent {
}
